/* eslint-disable */
import React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import {useStyles} from './SnackBarStyles';
import Alert from "@material-ui/lab/Alert";
import CheckIcon from "@material-ui/icons/Check";
import {Typography,Box} from '@material-ui/core'
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';


function Toast(props) {
    const classes = useStyles();
    const { open, closeHandler, alertMessage, severity,button ,message1,message2,setAccountActivate,
    handleOnReactivateAccountClick,
    selectedTeamMemberId ,handleModalOpen} = props;
  
    return (
      <Snackbar
        open={open}
        className={classes.snackBarStyle}
        autoHideDuration={8000}
        onClose={closeHandler}
        style={{width:'100%'}}

      >
        <Alert
          severity={severity !== "" ? severity : ""}
          iconMapping={{
            success: (
              <AccountCircleIcon className={classes.AccountIconCustom} fontSize="inherit" />
            ),
            error:(
               <WarningOutlinedIcon className={classes.checkIconCustom} fontSize="inherit" />
            )
          }}
          className={`${
            severity === "success"
              ? classes.toastSuccessMessage
              : classes.toastMessage
          }`}
          sx={{
            width: "100%",
            fontFamily:'Work Sans',
            fontWeight: "normal",
            fontSize: "16px",
            lineHeight: "20px",
            backgroundColor: button?'#F4FAF8':'#E0EFEE',
            color: '#142A39',
            letterSpacing: "-0.2px",
            "& .MuiAlert-message": {
                width: "100%",
              },
          }}
        >
          {/* {alertMessage} */}
          <Box style={{display:'flex',justifyContent:'space-between'}}>
          <Box>
          <Typography className={classes.message1}>{message1} </Typography>
          <Typography className={classes.message2}>{message2}</Typography>
          </Box>
         {button && <Box>
         <Button className={classes.PrimaryButton} onClick={handleModalOpen}>Reactivate Member</Button>
          </Box>}
          </Box>
        </Alert>
      </Snackbar>
    );
  }
  
  export default Toast;


// WEBPACK FOOTER //
// ./src/views/components/Modal/SnackBar.jsx